<script setup lang="ts">
interface Props {
  data: {
    show: boolean
  }
}

const props = withDefaults(defineProps<Props>(), {})

watch(
  () => props.data.show,
  (value: boolean) => {
    if (import.meta.client) {
      document.body.style.overflowY = value ? 'hidden' : 'auto'
    }
  },
  { immediate: true }
)
</script>

<template>
  <transition name="fade">
    <div v-if="data.show" class="loading">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1031;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 50%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.lds-ring {
  position: relative;
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  position: absolute;
  box-sizing: border-box;
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-color: #fff transparent transparent;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
